import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, isDevMode } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { AppRoutingModule } from './app-routing.module';
import { metaReducers } from './app-state';
import { AppComponent } from './app.component';
import { AuthEffects } from './auth/state/auth.effects';
import { authReducer } from './auth/state/auth.reducers';
import { MatPaginatorI18n } from './shared/common/services/paginator.i18n';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from './shared/shared.module';
import { SharedEffects } from './shared/state/shared.effects';
import { sharedReducer } from './shared/state/shared.reducers';
import { incidentReducer } from './incidents/state/incidents.reducers';
import { HttpConfigInterceptor } from './shared/common/interceptors/http-config-interceptor';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';
import { ServiceWorkerModule } from '@angular/service-worker';

export const defaultTooltipOptions: MatTooltipDefaultOptions = {
    showDelay: 0,
    hideDelay: 0,
    touchGestures: 'auto',
    touchendHideDelay: 0,
    disableTooltipInteractivity: true,
};

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [
        AppComponent,
    ],
    exports: [
        ReactiveFormsModule,
    ], imports: [AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatTableModule,
        MatSortModule,
        MatBadgeModule,
        MatPaginatorModule,
        MatSidenavModule,
        MatTooltipModule,
        MatMenuModule,
        MatSnackBarModule,
        SharedModule,
        LoggerModule.forRoot({
            level: NgxLoggerLevel.LOG,
            serverLogLevel: NgxLoggerLevel.OFF,
        }),
        // ngrx
        StoreModule.forRoot({}, { metaReducers }),
        StoreModule.forFeature('auth', authReducer),
        StoreModule.forFeature('shared', sharedReducer),
        StoreModule.forFeature('incidents', incidentReducer),
        StoreDevtoolsModule.instrument({
            name: 'DiCon',
            maxAge: 25,
            logOnly: true,
        }),
        EffectsModule.forRoot([AuthEffects, SharedEffects]),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        {
            provide: MatPaginatorIntl,
            useClass: MatPaginatorI18n,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        },
        {
            provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
            useValue: defaultTooltipOptions
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
